import OcomClientList from "./pages/ListPage.vue";
import OcomClientDetail from "./pages/FormPage.vue";
import OcomClientIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/ocom_client",
    component: OcomClientIndex,
    redirect: "/ocom_client/list",
    name: "ocom_client",
    children: [
      {
        path: "list",
        component: OcomClientList,
        name: "ocom_client.list",
      },
      {
        path: "create",
        component: OcomClientDetail,
        name: "ocom_client.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: OcomClientDetail,
        name: "ocom_client.edit",
        props: { create: false },
      },
    ],
  },
];
